<template>
  <div
    class="form__group"
    :class="{ '-has-helper': hasHelper, error: errors.has(inputId), '-has-label': label }"
  >
    <label v-if="showLabel" :for="labelFor || inputId">
      {{ label }}
      <slot name="label" />
    </label>
    <slot />
    <input-error v-if="showErrorMsg" :input-id="inputId" />
  </div>
</template>

<script>
// @flow
import InputError from './input-error.vue'
/**
 * Handles showing errors from v-validate
 * Expects an <input> in the <slot>
 */
export default {
  inject: ['$validator'],
  name: 'FormGroup',
  components: {
    InputError,
  },
  props: {
    // not currently used
    hasHelper: {
      type: Boolean,
      default: false,
    },
    inputId: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      default: '',
    },
    labelFor: {
      type: String,
      default: null,
    },

    // overrides, used bools to keep legacy code working
    showErrorMsg: {
      type: Boolean,
      default: true,
    },
    showLabel: {
      type: Boolean,
      default: true,
    },
  },
}
</script>
